import classnames from 'classnames';
import React, { ReactNode } from 'react';

export type CenterLayoutProps = {
    children?: ReactNode;
    className?: string;
};

function CenterLayout(props: CenterLayoutProps): React.JSX.Element {
    const { className } = props;

    return <div className={classnames(className, 'container mx-auto')}>{props.children}</div>;
}

export default CenterLayout;
